import { Checkbox, Flex, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

import type { ServiceOption } from './model'
import { ServiceSwitch } from './ServiceSwitch'
import { useStyle } from './styles'
import type { McpServiceId } from './types'

const { Text } = Typography

type Props = {
  workspaceId: number
  options: ServiceOption[]
  value: McpServiceId[]
  disabled: boolean
  onChange: (services: McpServiceId[]) => void
}

export const ServicePicker = ({
  workspaceId,
  options,
  value,
  disabled,
  onChange
}: Props) => {
  const { t } = useTranslation()
  const { styles, cx } = useStyle()

  return (
    <Checkbox.Group
      value={value}
      disabled={disabled}
      onChange={(next) => onChange(next as McpServiceId[])}
      aria-label={t('workspace.aiConnectors.connect.chooseService')}
      style={{ width: '100%' }}
    >
      <Flex vertical gap={8}>
        {options.map((option) => {
          const name = t(
            `workspace.aiConnectors.services.${option.service}.name`
          )
          const hint = option.blocked
            ? t(
                option.blocked === 'notInstalled'
                  ? 'workspace.aiConnectors.servicesTab.needsInstance'
                  : 'workspace.aiConnectors.servicesTab.notConfigured',
                { service: name }
              )
            : option.selectable
              ? t(
                  `workspace.aiConnectors.services.${option.service}.description`
                )
              : t('workspace.aiConnectors.connect.serviceOff')

          return (
            <Flex
              key={option.service}
              align="center"
              justify="space-between"
              gap={12}
              className={cx(
                styles.serviceRow,
                value.includes(option.service) && styles.serviceRowSelected
              )}
            >
              <Checkbox value={option.service} disabled={!option.selectable}>
                <Flex vertical>
                  <Text strong>{name}</Text>
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    {hint}
                  </Text>
                </Flex>
              </Checkbox>
              {option.policy ? (
                <ServiceSwitch
                  workspaceId={workspaceId}
                  policy={option.policy}
                />
              ) : null}
            </Flex>
          )
        })}
      </Flex>
    </Checkbox.Group>
  )
}
